var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImg5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 75,
    viewBox: "0 0 80 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 79.2253,
    height: 75,
    rx: 14,
    fill: "#5A47AB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 54H30.3521V38.1139H36.5H42.1086C42.5095 38.1139 43.0006 38.094 43.582 38.0542C44.1633 38.0144 44.7346 37.9546 45.2958 37.875C48.7837 37.3375 51.4397 35.8444 53.2638 33.3958C55.0879 30.9273 56 27.981 56 24.5569C56 21.1329 55.0879 18.1965 53.2638 15.7479C51.4597 13.2794 48.8038 11.7764 45.2958 11.2389C44.7346 11.1394 44.1633 11.0796 43.582 11.0597C43.0207 11.0199 42.5296 11 42.1086 11H25V54ZM41.9282 62.2687L30.3521 16.3153L41.9282 16.0465C42.3091 16.0465 42.7401 16.0664 43.2211 16.1062C43.7223 16.1461 44.1933 16.2157 44.6343 16.3153C46.719 16.7731 48.2224 17.8183 49.1445 19.4507C50.0666 21.0632 50.5276 22.7653 50.5276 24.5569C50.5276 26.3486 50.0666 28.0606 49.1445 29.6931C48.2224 31.3056 46.719 32.3407 44.6343 32.7986C44.1933 32.8981 43.7223 32.9678 43.2211 33.0076C42.7401 33.0475 45.2061 32.7389 42.5 33.0076L49.1445 62L41.9282 62.2687Z",
    fill: "#FBD15B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg5);
export default __webpack_public_path__ + "static/media/Img5.a7cf652ce046f5e419061b181a577908.svg";
export { ForwardRef as ReactComponent };